<template>
  <div class="pdf-card">
    <!-- src="https://archivogeneral.sanjuan.gob.ar/assets/pdf-icon-tRyEvnd-.svg"  -->
    <img src="/img/icons/pdficon.png" alt="Icono PDF" class="pdf-icon" />
    <h3 class="pdf-title">{{ title }}</h3>
    <button class="pdf-button" @click="viewPdf">Ver PDF</button>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    pdfUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    viewPdf() {
      window.open(this.pdfUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.pdf-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 250px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 255px;
}

.pdf-icon {
  width: 110px;
  height: 88px;
}

.pdf-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px;
}

.pdf-category {
  font-size: 0.9rem;
  color: #757575;
  margin: 10px 0;
}

.pdf-button {
  background-color: #ff5722;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}

.pdf-button:hover {
  background-color: #f44336;
}

.pdf-button:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
</style>
